/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */

export enum DateFormat {
  DATE_TIMEZONE = 'YYYY-MM-DDTHH:MM:SS.SSSZZ',
  YYYY_MM_DD = 'YYYY-MM-DD',
  MM_DD_YYYY = 'MM-DD-YYYY',
  DATE_TIME = 'YYYY-MM-DDTHH:MM:ss',
  YYYY_MM_DD_HH_MM = 'YYYY-MM-DD HH:MM',
  DATE_TIME_WITH_SPACE_START_TIME = 'YYYY-MM-DD 00:00:00',
  DATE_TIME_WITH_SPACE_END_TIME = 'YYYY-MM-DD 23:59:59',

  // Common date format through out application : Suggested by Momd. Abrar in bug : DUTFP-269
  NZ_DD_MMM_YYYY = 'dd-MMM-yyyy',
  NZ_DD_MM_YYYY = 'dd-MM-yyyy',
  DD_MMM_YYYY = 'DD-MMM-YYYY',
  hh_mm_AMPM = 'hh:mm A',
  DD_MMM_YYYY_hh_mm_AMPM = 'DD-MMM-YYYY hh:mm A',
  MM_DD_YYYY_HH_mm = 'DD-MM-YYYY HH:mm',
  DD_MM_YYYY = 'DD-MM-YYYY',
  HH_mm = 'HH:mm'
}

export interface MenuItem {
  label: string;
  link: string;
  icon: string;
  selected: boolean;
  hide: boolean;
  children: MenuItem[];
  operationName?: string;
  dashboardId?: string;
  filters?: string;
  open?: boolean; // mobile responsive handler
}

export interface UserTokenResponse {
  firstName: any;
  token: TokenResponse;
  user: UserResponse;
  appMenuJson: any;
  isBootstrapUser:boolean;
  scope?: [];
  dashboard?: any;
  customRole?: any;
  roles?: any;
  isFirstLogin: boolean;
  userType: string;
  dynamicRoles?: [];
  licenseActivityGroup?: string[];
}

export interface TokenResponse {
  accessToken?: string;
  refreshToken?: string;
  scope?: string;
  tokenType?: string;
  expiresIn?: number;
}

export interface UserResponse {
  firstName?: string;
  lastName?: string;
  email?: string;
  customerName?: string;
  blk?: boolean;
  customerId?: string;
  userName?: string;
  orgId?: string;
  orgnaizationName?: string;
  group?: UserGroup[];
  isAdmin?: boolean;
  isBootstrapUser?:boolean;
  sanctionDetails?: SanctionDetail[];
  userType?: string;
  id?: string;
  mobile?: string;
  countryCode?: string;
  photoPath: any;
  token?: string;
  refreshToken?: string;
  expiresIn?: number;
  dynamicRoles?: DynamicRoles[];
  licenseActivityGroup?: string[];
  companyDetails?: CompanyDetails;
  portCode?:any;
  portName?:any;
}

export interface DynamicRoles {
  typeId: number;
  serviceName: string;
  serviceGroup: string;
  label: string;
  icon: string;
  roles: string[];
}
export interface UserGroup {
  id: string;
  name: string;
  type: string;
  text?: string;
  value?: string;
}

export interface SanctionDetail {
  sanctionType: string;
  startDate: string;
  endDate: string;
  sanction: string;
  status: string;
  description: string;
}

export interface Error {
  code: string;
  cause: string;
  message: string;
}

export class ErrorResponse {
  exception!: string;
  fingerprint!: string;
  errors!: Error[];
  status!: string;
}

export interface SuccessErrorMessages {
  error: string[];
  success: string;
}

// export interface CompanyDetails {
//   loginId: string;
//   partyType: string;
//   partyName: string;
//   person: boolean;
//   organization: boolean;
//   status: string;
//   blocked?: any;
//   customerId: number;
//   accountNumber: string;
//   orgId: number;
//   customerType: string;
//   customerName: string;
//   orgnaizationName: string;
//   licenseActivityGroup?: any;
// }
export interface CompanyDetails {
  accountNo?:string;
  bpmnId?:string;
  businessDesc?:string;
  clientAddress?:any[];
  clientContact?:any[];
  clientId:number;
  clientName?:string;
  clientRegNo?:string;
  clientUUID?:string;
  creationDateTime?:string;
  legalRepresentative?:any[];
  licenseActivityGroup?:any;
  registrationType?:string;
  userId?: string;
  status?: string;
  terminationDateTime?: string;
  version?: any;
}

export interface File {
  fileName: string;
  name: string;
  status: string;
  showDownload: boolean;
  id: string;
  referenceId: string;
  docType: string;
  type: string;
  mime: string;
  isImageUrl: boolean;
  fileType: string;
}
